<template lang="html">
  <div class="footer">
    <div class="footer-talent">
      <div class="footer-talent__container">
        <div class="footer-talent__container_top">
          <div>
            Сasting Online ©{{ new Date().getFullYear() }}. All rights reserved
          </div>
          <div>
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a href="https://policies.google.com/terms">Terms of Service</a>
            apply
          </div>
        </div>
        <div class="footer-talent__container_info">
          <div class="footer-talent__container_info__links-wrapper">
            <div class="footer-talent__container_info_links">
              <div class="footer-talent__container_info_links-title">Меню</div>
              <ul>
                <li><a href="/">Головна</a></li>
                <li><a href="/price">Ціни</a></li>
                <li><a href="/talents">Актори</a></li>
                <li><a href="/talent-career">Для талантів</a></li>
                <li>
                  <a href="/politika-konfidencijnosti"
                    >Політика конфіденційності
                  </a>
                </li>
                <li>
                  <a href="/pravila-i-umovi-vikoristannya-platformi"
                    >Правила і умови використання платформи</a
                  >
                </li>
              </ul>
            </div>
            <div class="footer-talent__container_info_links">
              <div class="footer-talent__container_info_links-title">
                Договори публічної оферти
              </div>
              <ul>
                <li><a href="/z-kliyentom">З клієнтом</a></li>
                <li><a href="/z-talantom">З талантом</a></li>
                <li>
                  <a href="/pro-nadannya-reklamnih-poslug"
                    >Про надання рекламних послуг</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="footer-talent__container_info_contact">
            <div class="footer-talent__container_info_contact_social">
              <div class="footer-talent__container_info_contact_social-title">
                Контакти
              </div>
              <div class="footer-talent__container_info_contact_social_list">
                <a
                  href="https://www.facebook.com/fast.casting.online/"
                  class="footer-talent__container_info_contact_social_list-item"
                >
                  <Facebook />
                </a>
                <a
                  href="https://www.instagram.com/casting.online/"
                  class="footer-talent__container_info_contact_social_list-item"
                >
                  <Instagram />
                </a>
                <a
                  href="https://t.me/CastingOnline"
                  class="footer-talent__container_info_contact_social_list-item"
                >
                  <Telegram />
                </a>
                <a
                  href="mailto:support@castingonline.com.ua"
                  class="footer-talent__container_info_contact_social_list-item footer-talent__container_info_contact_social_list-item__support footer-talent__container_info_contact_social_list-item__support-desktop"
                >
                  support@castingonline.com.ua
                </a>
              </div>
              <a
                href="mailto:support@castingonline.com.ua"
                class="footer-talent__container_info_contact_social_list-item footer-talent__container_info_contact_social_list-item__support footer-talent__container_info_contact_social_list-item__support-mobile"
              >
                support@castingonline.com.ua
              </a>
            </div>
            <div class="footer-talent__container_info_contact_social_payments">
              <div
                class="footer-talent__container_info_contact_social_payments-title"
              >
                Оплата
              </div>
              <div
                class="footer-talent__container_info_contact_social_payments_list"
              >
                <MasterCard />
                <Visa />
                <Apple />
                <GooglePay />
              </div>
            </div>
          </div>
        </div>
        <div class="footer-talent__container_images">
          <img
            class="footer-talent__container_images-logo"
            src="/static/img/casting-online-footer.png"
            width="739"
            height="225"
            alt="casting-online-footer"
          />
          <div class="footer-talent__container_images-right">
            <img
              src="/static/img/Smiles.png"
              width="144"
              height="80"
              alt="smiles"
            />
            <img
              src="/static/img/casting-footer-recording.png"
              width="243"
              height="146"
              alt="smiles"
              class="footer-talent__container_images-people"
            />
          </div>
        </div>
        <div class="footer-talent__container_bottom">
          <div>
            Сasting Online ©{{ new Date().getFullYear() }}. All rights reserved
          </div>
          <div>
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a href="https://policies.google.com/terms">Terms of Service</a>
            apply
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Facebook from "@app/FooterTalentCareer/icons/Facebook.vue"
import Instagram from "@app/FooterTalentCareer/icons/Instagram.vue"
import Telegram from "@app/FooterTalentCareer/icons/Telegram.vue"
import Visa from "@app/FooterTalentCareer/icons/Visa.vue"
import MasterCard from "@app/FooterTalentCareer/icons/MasterCard.vue"
import Apple from "@app/FooterTalentCareer/icons/Apple.vue"
import GooglePay from "@app/FooterTalentCareer/icons/GooglePay.vue"

export default {
  name: "footer-talent-career",
  components: {
    GooglePay,
    Apple,
    MasterCard,
    Visa,
    Telegram,
    Instagram,
    Facebook,
  },
}
</script>
<style scoped lang="scss">
.footer {
  display: flex;
  justify-content: center;
  background: #250a55;

  &-talent {
    padding: 60px 80px 24px;

    max-width: 1440px;
    width: 100%;

    @media (max-width: 1023px) {
      padding: 60px 24px 24px;
    }

    &__container {
      display: flex;
      flex-direction: column;
      gap: 30px;

      @media (max-width: 1023px) {
        flex-direction: column-reverse;
      }

      &_info {
        display: flex;
        justify-content: space-between;
        gap: 30px;

        @media (max-width: 1023px) {
          flex-direction: column;
          gap: 32px;
        }

        &__links-wrapper {
          display: flex;
          gap: 92px;

          @media (max-width: 1279px) {
            gap: 30px;
          }

          @media (max-width: 1023px) {
            flex-direction: column;
            gap: 24px;
          }
        }

        &_links {
          display: flex;
          flex-direction: column;
          gap: 16px;

          &-title {
            font-weight: 400;
            font-size: 14px;
            font-family: "Inter", sans-serif;

            color: #ffffff80;
          }

          ul {
            display: flex;
            flex-direction: column;
            gap: 12px;

            li {
              font-weight: 500;
              font-size: 14px;
              font-family: "Inter", sans-serif;

              a {
                color: white;
              }
            }
          }
        }

        &_contact {
          display: flex;
          flex-direction: column;
          gap: 32px;

          margin-right: 32px;

          @media (max-width: 1279px) {
            margin-right: 0;
          }

          &_social {
            display: flex;
            flex-direction: column;
            gap: 16px;

            &-title {
              font-family: "Inter", sans-serif;

              font-weight: 400;
              font-size: 14px;
              color: #ffffff80;
            }

            &_list {
              display: flex;
              gap: 12px;

              &-item {
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 4px;

                width: 33px;
                height: 33px;
                background: #ffffff3d;

                &__support {
                  width: fit-content;
                  margin-left: 4px;
                  padding: 8px 10px;
                  font-weight: 500;
                  line-height: 1em;
                  font-family: "Inter", sans-serif;

                  color: #ede8ff;

                  &-desktop {
                    @media (max-width: 500px) {
                      display: none;
                    }
                  }

                  &-mobile {
                    display: none;

                    @media (max-width: 500px) {
                      display: block;
                      margin-left: 0;
                    }
                  }
                }
              }
            }

            &_payments {
              display: flex;
              gap: 16px;
              flex-direction: column;

              &-title {
                font-weight: 400;
                font-size: 14px;
                color: #ffffff80;
                font-family: "Inter", sans-serif;
              }

              &_list {
                display: flex;
                gap: 8px;
              }
            }
          }
        }
      }

      &_images {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;

        @media (max-width: 1330px) {
          flex-direction: column;
        }

        @media (max-width: 1023px) {
          margin-top: 0;
        }

        &-logo {
          @media (max-width: 1024px) {
            width: 100%;
            height: auto;
          }
        }

        &-right {
          margin-top: 30px;

          display: flex;
          gap: 24px;

          @media (max-width: 500px) {
            flex-direction: column;
            gap: 24px;
          }
        }

        &-people {
          @media (max-width: 500px) {
            height: 196px;
            width: 100%;
          }
        }
      }

      &_bottom {
        display: flex;
        justify-content: space-between;

        font-weight: 400;
        font-size: 14px;
        text-align: center;
        font-family: "Inter", sans-serif;

        @media (max-width: 1023px) {
          display: none;
        }

        color: #ffffff80;

        a {
          color: #8957fb;
        }
      }

      &_top {
        display: none;

        font-weight: 400;
        font-size: 14px;

        @media (max-width: 1023px) {
          display: flex;
          flex-direction: column;
          gap: 24px;

          margin-top: 2px;
        }

        color: #ffffff80;

        a {
          color: #8957fb;
        }
      }
    }
  }
}
</style>
